module.exports = __webpack_public_path__ + "static/media/4th_banner_item.2a781a41.png";